import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Container } from '../container';
import { Server } from '../server';
import { User } from '../user';

@Component({
  selector: 'naas-about',
  templateUrl: './debug.component.html',
  styleUrls: ['./debug.component.scss'],
  // eslint-disable-next-line @angular-eslint/prefer-standalone
  standalone: false,
})
export class DebugComponent implements OnInit {
  user: User;
  containers: Container[];
  selectedContainer: Container;
  server: Server;

  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    this.route.data.subscribe(data => {
      this.containers = data.containers;
      this.selectedContainer =
        this.selectedContainer !== undefined
          ? this.selectedContainer
          : this.containers.find(c => c.id === 1) || this.containers[0];
      this.user = data.user;
      this.server = data.server;
    });
  }
}
//     const postData = data !== undefined ? data: {};
